<div class="flash-form-container">
 
  <app-operation-success></app-operation-success>

  <app-operation-error></app-operation-error>

  <app-operation-warning></app-operation-warning>

</div>
